export default __webpack_public_path__ + "1f7240f000d100251cc4f6c0045dab12.svg";